module.exports = "<template> <sio-money-display value.bind=value></sio-money-display> </template> ";